import React from 'react';
import { Book, Film, ExternalLink } from 'lucide-react';
import { ChristianTip } from '../lib/christian-tips';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface ChristianTipCardProps {
  tip: ChristianTip;
}

export default function ChristianTipCard({ tip }: ChristianTipCardProps) {
  const formatDate = (dateString: string) => {
    return format(new Date(dateString), 'dd/MM/yyyy', { locale: ptBR });
  };

  return (
    <div className="bg-white rounded-xl shadow-elevation-1 hover:shadow-elevation-2 transition-shadow overflow-hidden h-full flex flex-col">
      <div className="relative aspect-[2/3] w-full">
        <img
          src={tip.cover_image}
          alt={tip.title}
          className="w-full h-full object-cover"
          onError={(e) => {
            // Fallback para imagem padrão em caso de erro
            (e.target as HTMLImageElement).src = 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80';
          }}
        />
        <div className="absolute top-2 right-2 bg-white px-2 py-1 rounded-full text-xs font-medium">
          {tip.age_rating}
        </div>
        <div className="absolute top-2 left-2 bg-brand-teal text-white px-2 py-1 rounded-full text-xs font-medium flex items-center gap-1">
          {tip.type === 'livro' ? (
            <>
              <Book className="h-3 w-3" />
              <span>Livro</span>
            </>
          ) : (
            <>
              <Film className="h-3 w-3" />
              <span>Filme</span>
            </>
          )}
        </div>
      </div>
      
      <div className="p-4 flex-1 flex flex-col">
        <h3 className="font-semibold text-brand-teal mb-2 line-clamp-2">{tip.title}</h3>
        <p className="text-gray-600 text-sm mb-4 line-clamp-3">{tip.description}</p>
        
        <div className="mt-auto">
          <p className="text-xs text-gray-500 mb-2">
            Publicado em {formatDate(tip.published_at)}
          </p>
          
          {tip.link && (
            <a
              href={tip.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-brand-teal hover:text-brand-teal/80 text-sm font-medium flex items-center gap-1"
            >
              <ExternalLink className="h-3 w-3" />
              {tip.type === 'livro' ? 'Comprar' : 'Assistir'}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}